// import $ from 'jquery'
// import _ from 'lodash'
//

// const DefaultOptions = {
//   title: '',
//   message: '',
//   type: 'primary',
//   icon: '',
//   keyboard: true,
//   closeOnClickBackdrop: true,
//   center: false,
//   showOkButton: true,
//   showCancelButton: false,
//   okButtonText: '',
//   cancelButtonText: '',
//   beforeClose: null,
// }
//
// const MessageType = {
//   ALERT: 0,
//   CONFIRM: 1,
// }
// import ModalManager from './ModalManager'
import _ from 'lodash'
import KModal from '../modal'
import KButton from '../button'
import KDefaultButton from '../default-button'

const DefaultOkButton = {
  text: '确定',
}

const DefaultCancelButton = {
  text: '取消',
  extra: {
    type: 'light',
    plainPlus: true,
  },
}

const defaultTheme = 'primary'

export default {
  name: 'KMessageBox',
  data() {
    return {
      visible: false,
      mounted: false,
      // API properties:
      centered: false,
      icon: '',
      type: 'primary', // 类型 primary（默认）, secondary, danger, success, warning, light, ...
      title: '', // 标题
      message: '', // 内容
      html: false, // 内容是 html 片段
      underline: '', // 重要提示 - 将出现在 message（如果存在）的下方，颜色会根据指定的 type 存在
      // 按钮的定义：
      // - Boolean 如果为 false 将不显示按钮
      // - String 如果为文本，将显示按钮，且值为按钮文本内容
      // - Object { text: String, type: String, icon: String, extra: Object }
      //    如果为对象，将显示按钮，其中
      //      text 为按钮文本内容，
      //      type 为按钮主题样式
      //      icon 为按钮主题图标
      //      extra - Object 作用在按钮的属性上
      okButton: DefaultOkButton,
      cancelButton: DefaultCancelButton,
      verticalCentered: true,
      showClose: false,
      keyboard: true,
      closeOnClickBackdrop: true,
      stack: false,
      width: 'auto',
      beforeClose: null,
    }
  },
  mounted() {
    this.mounted = true
  },
  watch: {
    visible(val) {
      if (!val && !this.emitByClick) {
        this.$emit('action', 'close')
      }
    },
  },
  methods: {
    doHide(actionType) {
      this.$emit('action', actionType)
      this.$nextTick(() => {
        this.emitByClick = false
      })
    },
    handleClick(actionType) {
      this.emitByClick = true
      if (this.beforeClose) {
        this.beforeClose(() => {
          this.doHide(actionType)
        })
      } else {
        this.doHide(actionType)
      }
    },
    renderAction(button, actionType) {
      const paramType = typeof button
      const DefaultButton = actionType === 'ok' ? DefaultOkButton : DefaultCancelButton
      if (paramType === 'boolean' && paramType === false) {
        return null
      }

      const component = actionType === 'ok' ? KButton : KDefaultButton

      if (paramType === 'string') {
        return (
          <component
            onClick={() => {
              this.handleClick(actionType)
            }}
            type={defaultTheme}
            // type={actionType ? this.type : 'light'}
          >
            {button || DefaultButton.text}
          </component>
        )
      }

      if (paramType !== 'object') {
        return null
      }

      // const buttonType = actionType ? (button.type || this.type) : 'light'
      const buttonType = button.type || defaultTheme
      const extraAttributes = button.extra || DefaultButton.extra || {}

      // vue的一个bug，子组件传值需要用 { props: Foo } { attrs: Bar }
      // 使用 attrs 会将属于 props 的部分作用到 props 上，剩下的作用到 attribute 上
      // 所以使用 attrs 传递即可
      const attrs = {
        attrs: extraAttributes,
      }

      return (
        <component
          icon={button.icon}
          type={buttonType}
          {...attrs}
          onClick={() => {
            this.handleClick(actionType)
          }}
        >
          {button.text || DefaultButton.text}
        </component>
      )
    },
    handleVisible(visible) {
      this.visible = visible
    },
    renderCustomFooter() {
      if (!this.footer) {
        return null
      }

      if (_.isFunction(this.footer)) {
        return this.footer()
      }

      return this.footer
    },
  },
  render() {
    const css = {
      'km-modal--message-box--width-specified': this.width !== 'auto',
    }

    const actions = (
      <template slot="footer">
        {this.renderCustomFooter()}
        {this.renderAction(this.cancelButton, 'cancel')}
        {this.renderAction(this.okButton, 'ok')}
      </template>
    )

    return (
      <KModal
        class={css}
        centered={this.centered}
        icon={this.icon}
        visible={this.visible}
        title={this.title}
        type={this.type}
        width={this.width}
        isMessageBox={this.theme !== 'modal'}
        keyboard={this.keyboard}
        closeOnClickBackdrop={this.closeOnClickBackdrop}
        verticalCentered={this.verticalCentered}
        showClose={this.showClose}
        onVisible={this.handleVisible}
        destroyOnHide={true}
        beforeClose={this.beforeClose}
      >
        {this.html ? <span domPropsInnerHTML={this.message} /> : this.message}
        {this.underline ? (
          <div class={{ [`has-text-${this.type}`]: true, 'km-message-box__underline': true }}>{this.underline}</div>
        ) : null}
        {actions}
      </KModal>
    )
  },
}
